/**
 * Created by wajidafaneh on 4/26/17.
 */
(function () {

    "use strict";

    var app = angular.module('harriApp');

    app.directive('enhancedStrapSelect', [function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: "../scripts/global-directives/enhanced_strap_select/enhanced_strap_select_directive.html",
            scope: {
                options: '='
            },
            link: function ($scope, element, attrs) {
                $scope.uniqueId = new Date().getTime();

                $scope.$on("enhanced_strap_select_directive.select", function (events, args) {
                    if ($scope.options.allStrapText && $scope.options.data.length === $scope.ngModel.length) {
                        $(element).html($scope.options.allStrapText + '<span class="caret"></span>');
                    }

                    setTimeout(function () {
                        $scope.$digest();
                    }, 1);
                });
            }
        }
    }]);
})();

